import React from "react";
import { ExecutionErrorRO, RoleRO } from "../../../api/api";
import { Dialog } from "../../../components/Hooks/Dialog/DialogProvider";
import PopupDialog from "../../../components/Form/PopupDialog";
import SettingsInfo from "../../../components/Settings/Old/Form/SettingsInfo";
import { DateTime } from "luxon";
import { makeStyles } from "@mui/styles";

interface Props {
    error: ExecutionErrorRO;
    roles: RoleRO[];
}

const useStyles = makeStyles({
    paper: {
        maxWidth: "1200px"
    }
});

const CreateExecutionDialog: Dialog<void, Props> = props => {
    const classes = useStyles();

    const {
        error,
        roles,
        onAccept
    } = props;

    return (
        <PopupDialog
            open
            paperClassName={classes.paper}
            onFirst={onAccept}
            firstTitle="Fertig"
            title="Error-Details">

            <SettingsInfo
                label="Zeitpunkt"
                value={DateTime.fromISO(error.timestamp).toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS)} />

            <SettingsInfo
                label="Rolle"
                value={roles.find(r => r.id === error.roleId)?.name ?? "Unbekannt"} />

            <SettingsInfo
                label="Rollenversion"
                value={error.roleVersion} />

            <SettingsInfo
                label="Fehler"
                value={error.error} />

            <SettingsInfo
                label="Stacktrace"
                value={error.stacktrace ?? ""} />

        </PopupDialog>
    );
};

export default CreateExecutionDialog;
